import {
    Autocomplete,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
} from "@mui/material";

const NotificacionPlantillasDialog = ({
    open,
    editing,
    form,
    categories,
    canSave,
    isSaving,
    onClose,
    onSave,
    onNombreChange,
    onCategoriaChange,
    onDescripcionChange,
}) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{editing ? "Editar plantilla" : "Nueva plantilla"}</DialogTitle>
            <DialogContent>
                <Stack spacing={2} mt={1}>
                    <TextField
                        label="Nombre"
                        value={form.nombre}
                        onChange={(e) => onNombreChange(e.target.value)}
                    />
                    <Autocomplete
                        freeSolo
                        options={categories || []}
                        value={form.categoria || ""}
                        onChange={(event, value) => onCategoriaChange(value || "")}
                        onInputChange={(event, value) => onCategoriaChange(value || "")}
                        renderInput={(params) => <TextField {...params} label="Categoria" />}
                    />
                    <TextField
                        label="Descripcion"
                        multiline
                        minRows={5}
                        value={form.descripcion}
                        onChange={(e) => onDescripcionChange(e.target.value)}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button variant="contained" onClick={onSave} disabled={!canSave || isSaving}>
                    {isSaving ? "Guardando..." : "Guardar"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NotificacionPlantillasDialog;
